import React from 'react';
import { CheckCircle, Users, Building, TrendingUp, Zap, BarChart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { mockData } from '../mock';

const Consulting = () => {
  return (
    <div className="min-h-screen pt-32 md:pt-36">
      {/* Hero */}
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block bg-[#D3FF62] px-4 py-2 rounded-full mb-6">
                <span className="text-[#004534] font-semibold text-sm">Digital Consulting Hub</span>
              </div>
              <h1 className="display-large mb-6">Digital Fitness & Recreation Consulting</h1>
              <p className="body-large mb-8">
                Transform your fitness business or recreation center with cutting-edge technology solutions. 
                Our expert consultants bring 20+ years of experience to optimize your operations and drive growth.
              </p>
              <Link to="/contact" className="btn-primary">
                Schedule Consultation
              </Link>
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1758875568756-37a9c5c1a4f2"
                alt="Consulting Services"
                className="w-full h-auto rounded-[32px] shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 md:py-24 bg-[#FAFAFF]">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="heading-1 mb-4">Our Consulting Services</h2>
            <p className="body-large">Comprehensive solutions for modern fitness and recreation businesses</p>
          </div>

          <div className="network-grid">
            {mockData.consultingServices.map((service, index) => {
              const icons = [Users, Building, TrendingUp, Zap, BarChart, CheckCircle];
              const IconComponent = icons[index % icons.length];
              return (
                <div key={index} className="network-card">
                  <div className="bg-[#D3FF62] w-16 h-16 rounded-2xl flex items-center justify-center mb-4">
                    <IconComponent size={32} className="text-[#004534]" />
                  </div>
                  <h3 className="network-card-title">{service}</h3>
                  <p className="network-card-content">
                    Expert guidance and implementation support for {service.toLowerCase()}.
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="heading-1 mb-4">Our Consulting Process</h2>
            <p className="body-large">A proven methodology for successful transformation</p>
          </div>

          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              {[
                { step: '01', title: 'Assessment', description: 'Comprehensive analysis of current systems and needs' },
                { step: '02', title: 'Strategy', description: 'Custom technology roadmap and implementation plan' },
                { step: '03', title: 'Implementation', description: 'Hands-on deployment and integration support' },
                { step: '04', title: 'Optimization', description: 'Ongoing monitoring and performance improvement' }
              ].map((phase, index) => (
                <div key={index} className="text-center">
                  <div className="bg-[#D3FF62] text-[#004534] text-2xl font-bold rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                    {phase.step}
                  </div>
                  <h3 className="heading-3 mb-2">{phase.title}</h3>
                  <p className="body-small">{phase.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 md:py-24 bg-[#CACAFC]">
        <div className="container">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="heading-1 mb-6">Start Your Transformation</h2>
            <p className="body-large mb-8">
              Our consulting clients consistently achieve remarkable improvements in efficiency, 
              satisfaction, and ROI. Ready to transform your fitness or recreation business?
            </p>
            <Link to="/contact" className="btn-primary">
              Schedule Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Consulting;